import { COLORS, RADIUS, FONTS } from "../../theme";

const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.65)",
      display: "flex",
      justifyContent: "end",
      alignItems: "center",
      zIndex: 1000,
    },
    chatContainer: {
        position: "fixed",  // Stays fixed on screen
        insetInlineEnd: "1px",
        top: "108px",        // Below the fixed navbar — was "0", which hid
                              // the chat header underneath the nav (nav has
                              // a higher z-index than this panel).
        bottom: "88px",       // Clears the floating region/language pill —
                              // was a plain height, which let the input row
                              // sink to the very bottom of the screen and
                              // collide with the pill.
        width: "320px",
        backgroundColor: COLORS.dark,
        color: "rgb(255, 255, 255)",
        border: "1px solid rgba(255,255,255,0.08)",
        boxShadow: "0 30px 80px rgba(0,0,0,0.5)",
        display: "flex",
        flexDirection: "column",
    },
    
    closeButton: {
      cursor: "pointer",
      fontSize: "22px",
      lineHeight: 1,
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      color: COLORS.white,
      background: "rgba(255,255,255,0.08)",
      border: "none",
      flexShrink: 0,
    },
    eventsList: {
        flex: "8.5",   // Takes 80% of the height
        padding: "15px",
        overflowY: "auto", // Enables scrolling if messages exceed space
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        scrollbarWidth: "thin", /* For Firefox */
        scrollbarColor: "#888 #333", /* Thumb & Track colors */
        "::-webkit-scrollbar": {
        width: "6px", /* Slim width */
        },
        "::-webkit-scrollbar-track": {
            background: COLORS.gray, /* Track color */
            borderRadius: "5px",
        },

        "::-webkit-scrollbar-thumb": {
            background: "#888", /* Thumb color */
            borderRadius: "5px",
        },

        "::-webkit-scrollbar-thumb:hover": {
            background: "#aaa", /* Lighter on hover */
        },
    },
    
      eventItem: {
        background: COLORS.gray,
        border: "1px solid rgba(255,255,255,0.06)",
        padding: "12px",
        marginBottom: "8px",
        borderRadius: RADIUS.input,
      },
      eventHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
        fontWeight: "700",
        color: "#fff",
      },
      userList: {
        marginTop: "8px",
        paddingLeft: "10px",
        borderLeft: `2px dashed rgba(255,255,255,0.15)`,
        maxHeight: "200px", // Limit height
        overflowY: "auto",  // Enable scrolling
        scrollbarWidth: "thin", // Firefox scrollbar styling
        scrollbarColor: "#666 #333", // Custom scrollbar colors
      },
      chatIcon: {
        color: COLORS.peach,
        fontSize: "18px",
      },
      chatIconBlack: {
        color: COLORS.gray,
        fontSize: "18px",
      },
      
      generalChatItem: {
        fontWeight: "700",
        padding: "10px",
        textAlign: "center",
        background: "rgba(212,175,55,0.12)",
        border: `1px solid ${COLORS.gold}`,
        borderRadius: RADIUS.pill,
        cursor: "pointer",
        color: COLORS.gold,
        marginBottom: "8px",
      },
      userItem: {
        display: "flex",
  alignItems: "center",
  justifyContent: "space-between", // Push icon to the right
  padding: "10px",
  borderBottom: "1px solid rgba(255,255,255,0.06)",
  cursor: "pointer",
  '&:hover': {
    backgroundColor: "rgba(255,255,255,0.04)",
  },
      },
      userItemHover: {
        background: "#444",
      },
      userAvatar: {
        width: "45px",
        height: "45px",
        borderRadius: "50%",
        marginRight: "8px",
        marginleft: "8px",
      },
      avatar: {
        width: "33px",
        height: "33px",
        borderRadius: "50%",
      },
    chatHeader: {
        backgroundColor: "rgba(26,26,26,0.95)",
        backdropFilter: "blur(16px)",
        padding: "16px",
        color: COLORS.white,
        fontSize: "18px",
        fontFamily: FONTS.heading,
        fontWeight: "700",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid rgba(255,255,255,0.08)",
        flex: "0.7",   // Takes 10% of the height
    },
    
    chatMessages: {
        flex: "8.5",   // Takes 80% of the height
        padding: "15px",
        overflowY: "auto", // Enables scrolling if messages exceed space
        display: "flex",
        flexDirection: "column",
        gap: "10px",
        scrollbarWidth: "thin", /* For Firefox */
        scrollbarColor: "#888 #333", /* Thumb & Track colors */
        "::-webkit-scrollbar": {
        width: "6px", /* Slim width */
        },
        "::-webkit-scrollbar-track": {
            background: COLORS.gray, /* Track color */
            borderRadius: "5px",
        },

        "::-webkit-scrollbar-thumb": {
            background: "#888", /* Thumb color */
            borderRadius: "5px",
        },

        "::-webkit-scrollbar-thumb:hover": {
            background: "#aaa", /* Lighter on hover */
        },
    },
    
    chatInputContainer: {
        display: "flex",
        padding: "12px",
        gap: "8px",
        borderTop: "1px solid rgba(255,255,255,0.08)",
        backgroundColor: COLORS.dark,
        flex: "0.8",   // Takes 10% of the height
    },
    chatInput: {
      flex: 1,
      padding: "10px 14px",
      borderRadius: RADIUS.pill,
      border: "1px solid rgba(255,255,255,0.12)",
      outline: "none",
      backgroundColor: COLORS.gray,
      color: "#fff",
    },
    sendButton: {
      padding: "0px 16px",
      borderRadius: RADIUS.pill,
      border: "none",
      backgroundColor: COLORS.peach,
      color: COLORS.dark,
      cursor: "pointer",
      fontSize:"20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    messageWrapper: (isUser) => ({
      display: "flex",
      alignItems: "center",
      justifyContent: isUser ? "flex-end" : "flex-start",
      gap: "10px",
    }),
    userBubble: {
      width: 33,
      cursor:"pointer",
      height: 33,
      backgroundColor: '#FFBA83',
      color: 'white',
      borderRadius: '50%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 21,
      fontWeight: 'bold',
      verticalAlign: 'middle', // Aligns with text baseline
      marginRight: 8, // Optional spacing from the message text
    },
    messageContent: {
      display: "flex",
      flexDirection: "column",
      backgroundColor: "rgba(212,175,55,0.16)",
      border: `1px solid rgba(212,175,55,0.35)`,
      padding: "10px",
      borderRadius: RADIUS.input,
      width: 'fit-content'
    },
    backButton:{
        cursor:"pointer",
        padding:"10px",
        fontSize:"23px"
    },
    messageContentRight: {
    flexDirection: "column",
    backgroundColor: COLORS.gray,
    border: "1px solid rgba(255,255,255,0.08)",
    padding: "10px",
    borderRadius: RADIUS.input,
    width: "fit-content",
    /* align-items: flex-end, */
    /* align-self: flex-end, */
    float: "right",
      },
    messageText: {
      fontSize: "14px",
    },
    messageTime: {
      fontSize: "10px",
      color: "#888",
      marginTop: "5px",
    },
    headDivider: {
        height: "1px",
        backgroundColor: "rgba(255,255,255,0.08)",
        margin: "15px 0",
      },
      headHeading: {
        fontSize: "13px",
        fontWeight: "700",
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: COLORS.gold,
        textAlign: "center",
        marginBottom: "10px",
      },
      headUserChats: {
        padding: "1px",
        backgroundColor: "transparent",
        borderRadius: RADIUS.input,
      },
      headChatHeadItem: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        cursor: "pointer",
        backgroundColor: COLORS.gray,
        border: "1px solid rgba(255,255,255,0.06)",
        borderRadius: RADIUS.input,
        marginBottom: "8px",
      },
      userChatBubbleGold:{
        width: 50,
        height: 50,
        borderRadius: "50%",
        backgroundColor: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        color: COLORS.peach,
        fontSize: "20px",
        textTransform: "uppercase",
      },
      userChatBubble:{
        width: 30,
        height: 30,
        borderRadius: "50%",
        backgroundColor: COLORS.peach,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "bold",
        color: COLORS.gray,
        fontSize: 14,
        textTransform: "uppercase",
      },
      userChatName:{
        paddingLeft:"5px"
      },
      headAvatar: {
        width: "30px",
        height: "30px",
        borderRadius: "50%",
        marginRight: "10px",
      },
      headChatIcon: {
        color: COLORS.peach,
        fontSize: "18px",
      },
      headNoChats: {
        textAlign: "center",
        color: "#888",
        fontSize: "14px",
      },
    
    messageBubble: (isUser) => ({
      maxWidth: "75%",
      padding: "10px",
      borderRadius: "10px",
      marginBottom: "8px",
      backgroundColor: isUser ? COLORS.peach : COLORS.gray,
      color: "#fff",
      alignSelf: isUser ? "flex-end" : "flex-start",
    }),
  };
  
  export default styles;
